import dynamic from 'next/dynamic'

export const BentoSquare = dynamic(() => import('./bento-square'))
